"use client";

import { Dropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";

const Profile = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { user } = useContext(AuthContext);

  if (!user) return null;

  return (
    <Dropdown className="admin-profile">
      <Dropdown.Toggle className="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor">
        <div className="flex-shrink-0">
          <img
            className="rounded-circle wh-40 administrator"
            src={user.profile_picture || "/images/administrator.jpg"}
            alt="user"
            width={40}
            height={40}
          />
        </div>

        <div className="flex-grow-1 ms-2 d-none d-xxl-block">
          <h3 className="mb-0">{user.name}</h3>
          <span className="fs-12 text-muted">{user.role}</span>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="border-0 bg-white dropdown-menu-end">
        <div className="d-flex align-items-center info">
          <div className="flex-shrink-0">
            <img
              className="rounded-circle wh-30 administrator"
              src={user.profile_picture || "/images/administrator.jpg"}
              alt="user"
              width={30}
              height={30}
            />
          </div>
          <div className="flex-grow-1 ms-2">
            <h3 className="fw-medium mb-0">{user.name}</h3>
            <span className="fs-12">{user.role}</span>
          </div>
        </div>

        <ul className="admin-link ps-0 mb-0 list-unstyled">
          <li>
            <Link
              to="/settings/account-settings"
              className={`dropdown-item d-flex align-items-center text-body ${
                pathname === "/settings/account-settings" ? "activeLink" : ""
              }`}
            >
              <i className="material-symbols-outlined">settings</i>
              <span className="ms-2">Profile Settings</span>
            </Link>
          </li>

          <li>
            <a
              href="/authentication/logout"
              className="dropdown-item d-flex align-items-center text-body"
            >
              <i className="material-symbols-outlined">logout</i>
              <span className="ms-2">Logout</span>
            </a>
          </li>
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Profile;
